// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-footer-page-footer-341a3{background-color:var(--GRAY_11);bottom:0;box-shadow:0 1px 10px 0 rgba(0,0,0,.1);box-sizing:border-box;display:flex;left:0;padding:10px 16px;position:fixed;width:100vw;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-footer": "page-footer-page-footer-341a3",
	"pageFooter": "page-footer-page-footer-341a3"
};
export default ___CSS_LOADER_EXPORT___;
